import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputDefault from '../../../../components/InputDefault/index.js';
import SelectDefault from '../../../../components/SelectDefault/index.js';
import LoadingCard from './LoadingCard';
import { CardContainer, CardHeader, CardBody, FormGroup } from './CardStyles';
import api from '../../../../services/api.js';
import moment from 'moment';

const ConsumptionUnitCard = ({ idDm011, onDataUpdate }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [consumptionData, setConsumptionData] = useState({
    idDm011: 0,
    nrUnidadeConsumo: 0,
    nmUnidadeConsumo: '',
    idDm003: 0,
    idDm006: 0,
    idDm009: 0,
    idDm012: 0,
    dsEndereco: '',
    nmBairro: '',
    dsComplemEndereco: '',
    nmCidade: '',
    nrCep: 0,
    dtAlteracao: '',
    nmUsuario: ''
  });
  
  const [dm003List, setDm003List] = useState([]);
  const [dm006List, setDm006List] = useState([]);
  const [dm012List, setDm012List] = useState([]);

  const formatDate = (dateStr) => {
    if (dateStr === '' || dateStr === null) {
      return '';
    }
    return moment(dateStr).format('YYYY-MM-DD');
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!idDm011) return;
      
      try {
        setIsLoading(true);
        
        // Fetch lists in parallel
        const [supplierResponse, subClassResponse, connectionResponse, consumptionResponse] = await Promise.all([
          api.get(`supplier?situacao=A`),
          api.get(`sub_class`),
          api.get(`connection_type`),
          api.get(`consumption_unit?id=${idDm011}`)
        ]);

        if (supplierResponse.status === 200) {
          setDm003List(supplierResponse.data.data);
        }

        if (subClassResponse.status === 200) {
          setDm006List(subClassResponse.data.data);
        }

        if (connectionResponse.status === 200) {
          setDm012List(connectionResponse.data.data);
        }

        if (consumptionResponse.status === 200) {
          const data = consumptionResponse.data.data[0];
          const updatedData = {
            idDm011: data.ID_DM011,
            nrUnidadeConsumo: data.NR_UNIDADE_CONSUMO,
            nmUnidadeConsumo: data.NM_UNIDADE_CONSUMO,
            idDm003: data.ID_DM003,
            idDm006: data.ID_DM006,
            idDm009: data.ID_DM009,
            idDm012: data.ID_DM012,
            dsEndereco: data.DS_ENDERECO,
            nmBairro: data.NM_BAIRRO,
            dsComplemEndereco: data.DS_COMPLEM_ENDERECO,
            nmCidade: data.NM_CIDADE,
            nrCep: data.NR_CEP,
            dtAlteracao: formatDate(data.DT_ALTERACAO),
            nmUsuario: data.NM_USUARIO,
            idDm001: data.ID_DM001
          };
          
          setConsumptionData(updatedData);
          onDataUpdate(updatedData);
        }
        
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Erro ao buscar dados da unidade de consumo:', error);
      }
    };

    fetchData();
  }, [idDm011, onDataUpdate]);

  const handleChange = (field, value) => {
    const updatedData = { ...consumptionData, [field]: value };
    setConsumptionData(updatedData);
    onDataUpdate(updatedData);
  };

  if (isLoading) {
    return <LoadingCard title="Carregando Dados da Unidade de Consumo..." />;
  }

  return (
    <CardContainer>
      <CardHeader>
        <h5>Dados da Unidade de Consumo</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} md={3}>
            <FormGroup>
              <InputDefault
                placeholder=""
                Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nmUnidadeConsumo}
              onChange={(e) => handleChange('nmUnidadeConsumo', e.target.value)}
              Text={'Nome da UC'}
            />
            </FormGroup>
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nrUnidadeConsumo}
              onChange={(e) => handleChange('nrUnidadeConsumo', e.target.value)}
              Text={'Número da UC'}
              type={'number'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.dtAlteracao}
              onChange={(e) => handleChange('dtAlteracao', e.target.value)}
              Text={'Data de Alteração'}
              type={'date'}
              readOnly
            />
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nmUsuario}
              onChange={(e) => handleChange('nmUsuario', e.target.value)}
              Text={'Usuário'}
              readOnly
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <SelectDefault
              Width={'100%'}
              Margin={'10px 0px 15px 0px'}
              Text={'Distribuidora'}
              value={`${consumptionData.idDm003}`}
              onChange={(e) => handleChange('idDm003', e.target.value)}>
              {dm003List && dm003List.length > 0 ? (
                dm003List.map((item) => (
                  <option key={item.ID_DM003} value={item.ID_DM003}>
                    {item.NM_DISTRIBUIDORA} ({item.ID_DM003})
                  </option>
                ))
              ) : (
                <option disabled>Carregando lista...</option>
              )}
            </SelectDefault>
          </Col>
          <Col xs={12} md={4}>
            <SelectDefault
              Width={'100%'}
              Margin={'10px 0px 15px 0px'}
              Text={'Subclasse'}
              value={`${consumptionData.idDm006}`}
              onChange={(e) => handleChange('idDm006', e.target.value)}>
              {dm006List && dm006List.length > 0 ? (
                dm006List.map((item) => (
                  <option key={item.ID_DM006} value={item.ID_DM006}>
                    {item.NM_SUBCLASSE} ({item.ID_DM006})
                  </option>
                ))
              ) : (
                <option disabled>Carregando lista...</option>
              )}
            </SelectDefault>
          </Col>
          <Col xs={12} md={4}>
            <SelectDefault
              Width={'100%'}
              Margin={'10px 0px 15px 0px'}
              Text={'Ligação'}
              value={`${consumptionData.idDm012}`}
              onChange={(e) => handleChange('idDm012', e.target.value)}>
              {dm012List && dm012List.length > 0 ? (
                dm012List.map((item) => (
                  <option key={item.ID_DM012} value={item.ID_DM012}>
                    {item.NM_LIGACAO} ({item.ID_DM012})
                  </option>
                ))
              ) : (
                <option disabled>Carregando lista...</option>
              )}
            </SelectDefault>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.dsEndereco}
              onChange={(e) => handleChange('dsEndereco', e.target.value)}
              Text={'Endereço'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nmBairro}
              onChange={(e) => handleChange('nmBairro', e.target.value)}
              Text={'Bairro'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nmCidade}
              onChange={(e) => handleChange('nmCidade', e.target.value)}
              Text={'Cidade'}
            />
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.dsComplemEndereco}
              onChange={(e) => handleChange('dsComplemEndereco', e.target.value)}
              Text={'Complemento'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={consumptionData.nrCep}
              onChange={(e) => handleChange('nrCep', e.target.value)}
              Text={'CEP'}
              type={'number'}
            />
          </Col>
        </Row>
      </CardBody>
    </CardContainer>
  );
};

export default ConsumptionUnitCard;
